import { ShieldCheck, Lock, Shield, CheckCircle2, BadgeCheck, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

export default function PrivacyPolicy() {
return (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.3, duration: 0.5 }}
    whileHover={{ y: -3 }}
    className="relative bg-white/90 backdrop-blur-sm p-6 rounded-2xl border border-gray-100 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden"
  >
    {/* Decorative security gradient */}
    <div className="absolute -right-10 -top-10 w-32 h-32 rounded-full bg-green-100/40 filter blur-xl -z-0" />
    
    <div className="relative z-10">
      <div className="flex items-center gap-3 mb-6">
        <div className="p-2 rounded-lg bg-green-50 border border-green-100 shadow-sm">
          <ShieldCheck className="w-5 h-5 text-green-600" />
        </div>
        <h3 className="text-xl font-bold bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text text-transparent">
          Data Protection & Privacy
        </h3>
      </div>

      <div className="space-y-4 text-sm text-gray-600 leading-relaxed">
        <motion.p 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="p-4 bg-green-50/50 rounded-lg border border-green-100"
        >
          <Lock className="w-4 h-4 inline mr-2 text-green-500" />
          We respect your privacy and are committed to protecting your data. Your analytics and
          personal information are securely stored and never shared without consent.
        </motion.p>

        <motion.p 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="p-4 bg-blue-50/50 rounded-lg border border-blue-100"
        >
          <Shield className="w-4 h-4 inline mr-2 text-blue-500" />
          AdblastX uses encrypted connections and secure tokens to ensure your information stays
          private and safe at all times.
        </motion.p>

        <motion.ul 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-3"
        >
          {[
            "No personal data is sold or shared with third parties",
            "All data stored on secure, GDPR-compliant servers",
            "HTTPS and encryption protocols protect transmissions",
            "Tracking is anonymized for performance metrics only",
            "Full user control over data access and deletion",
            "Functional cookies only—no cross-site tracking",
            "Regular compliance audits and security checks"
          ].map((item, index) => (
            <motion.li
              key={index}
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.7 + index * 0.05 }}
              className="flex items-start p-3 rounded-lg hover:bg-gray-50/50 transition-colors"
            >
              <CheckCircle2 className="w-4 h-4 mt-0.5 mr-2 text-green-500 flex-shrink-0" />
              <span>{item}</span>
            </motion.li>
          ))}
        </motion.ul>
      </div>

      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1 }}
        className="mt-6 pt-4 border-t border-gray-100 flex flex-wrap justify-between items-center gap-3"
      >
        <div className="flex items-center text-xs text-gray-500">
          <BadgeCheck className="w-4 h-4 mr-1 text-green-500" />
          Last updated: {new Date().toLocaleDateString()}
        </div>
        <button className="text-sm font-medium text-green-600 hover:text-green-800 flex items-center transition-colors group">
          Read full policy
          <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
        </button>
      </motion.div>
    </div>
  </motion.div>
);

}
